import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IFandCGeneratorState } from '../types/fandc-generator.state';

export const selectFandCGeneratorState =
  createFeatureSelector<IFandCGeneratorState>('fandCGenerator');

export const selectedLoanNumber = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedLoanNumber
);
export const selectSelectedTemplateType = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedTemplateType
);
export const selectCategory = createSelector(
  selectFandCGeneratorState,
  (state) => state.category
);
export const selectTasks = createSelector(
  selectFandCGeneratorState,
  (state) => state.tasks
);
export const selectPersistencePayload = createSelector(
  selectFandCGeneratorState,
  (state) => ({
    loanNumber: state.selectedLoanNumber,
    templateType: state.selectedTemplateType,
    category: state.category,
    tasks: state.tasks,
  })
);
export const selectTemplates = createSelector(
  selectFandCGeneratorState,
  (state) => state.templates
);
export const selectTemplateTypes = createSelector(
  selectFandCGeneratorState,
  (state) => state.templateTypes
);
export const selectDefaultTasksForTemplate = createSelector(
  selectFandCGeneratorState,
  (state) => state.defaultTasksForTemplate
);

export const selectSelectedDefaultTasks = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedDefaultTasks
);

export const selectPrototypeTasks = createSelector(
  selectFandCGeneratorState,
  (state) => state.prototypeTasks
);

export const selectFilteredPrototypeTasks = createSelector(
  selectPrototypeTasks,
  selectSelectedDefaultTasks,
  (prototypeTasks, selectedDefaultTasks) => {
    // console.log('prototypeTasks', prototypeTasks);
    // console.log('selectedDefaultTasks', selectedDefaultTasks);
    if (!selectedDefaultTasks || selectedDefaultTasks.length === 0) {
      return [];
    }
    return prototypeTasks.filter((task) =>
      selectedDefaultTasks.includes(task.taskId)
    );
  }
);

export const selectSelectedPrototypeTasks = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedPrototypeTasks
);

export const selectReferenceDate = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedReferenceDate
);

export const selectMaturityDate = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedMaturityDate
);

export const selectedFrequency = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedFrequency
);

export const selectFrequencyOptions = createSelector(
  selectFandCGeneratorState,
  (state) => state.frequencyOptions
);


export const selectFrequencyOffsetOptions = createSelector(
  selectFandCGeneratorState,
  (state) => state.frequencyOffsetOptions
);

export const selectFrequencyOffsetValue = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedFrequencyOffsetValue
);

export const selectFormatOptions = createSelector(
  selectFandCGeneratorState,
  (state) => state.formatOptions
);

export const selectSelectedFormatOption = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedFormatOption
);

export const selectFirstDueDate = createSelector(
  selectFandCGeneratorState,
  (state) => state.firstDueDate
);

export const selectLoans = createSelector(
  selectFandCGeneratorState,
  (state) => state.loans
);

export const selectLoanDetail = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedLoanDetail
);

export const selectReportEntityOptions = createSelector(
  selectFandCGeneratorState,
  (state) => state.reportEntityOptions
);

export const selectSelectedReportEntity = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedReportEntity
);

export const selectEntityNameOptions = createSelector(
  selectFandCGeneratorState,
  (state) => state.entityNameOptions
);

export const selectSelectedEntityName = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedEntityName
);

export const selectGeneratedTasks = createSelector(
  selectFandCGeneratorState,
  (state) => state.generatedTasks
);

export const selectRootTemplate = createSelector(
  selectFandCGeneratorState,
  (state) => state.rootTemplate
);

export const selectTaskId = createSelector(
  selectFandCGeneratorState,
  (state) => state.taskId
);

export const selectTaskGenerationMetadataId = createSelector(
  selectFandCGeneratorState,
  (state) => state.taskGenerationMetadataId
);

export const selectSelectedLoanDetail = createSelector(
  selectFandCGeneratorState,
  (state) => state.selectedLoanDetail
);
